import type { W3cfState } from './type'

export const initW3cfState: W3cfState = {
  w3cfsByAll: [],
  w3cfsByPublic: [],
  w3cfsByStudent: [],
  w3cf: null,
}
